
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import importar from './lista-buscador-importar.vue';
    import presets from './lista-buscador-presets.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            presets,
            importar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Estado() { return this.Controlador.Vista.Estado; }

    }
